module.exports = __webpack_public_path__ + "static/media/retweet-alt.5d3c624b.svg";